module.exports = __webpack_public_path__ + "img/Picture4.d59ff702.png";